import Vuex from 'vuex'
import ElementUI from 'element-ui'
import Clipboard from 'v-clipboard'
import Components from '../components'
import noSAASComponents from '../noSAAS/components'
import installComps from '@/weappTmps/reg.js'
//vue plugins
import vuePlugins from './vuePlugins'
//vue extend
import vueExtend from './vueExtend'

const plugins = {
  Vuex,
  ElementUI,
  Clipboard,
  Components,
  installComps,
  ...noSAASComponents
}
function install (Vue) {
  for (let i in plugins) {
    Vue.use(plugins[i])
  }
}
export default install
